export default "__VITE_ASSET__LLYTVmcJ__"